<template>
  <div class="flex flex-col gap-y-6">
    <p class="font-bold text-base text-[#323232] text-left">Trocas e jornada</p>

    <!-- CONTRATO INVERTIDO do DropdownCard: start-open="false" inicia ABERTO. -->
    <DropdownCard
      title="Nossa Equipe (Time Interno)"
      subtitle="Médicos do seu time, contratados e gerenciados pela sua empresa."
      :start-open="false"
      test-id="our-team-accordion-toggle"
    >
      <TeamExchangeConfigBlock
        :config="stepExchangeConfig.ourTeam"
        :errors="ourTeamErrors"
        :on-clear-error="clearOurTeamError"
        testid-prefix="our-team"
      />
    </DropdownCard>

    <!-- CONTRATO INVERTIDO do DropdownCard: start-open="true" inicia FECHADO. -->
    <DropdownCard
      title="Equipe da Unidade (Time Externo)"
      subtitle="Médicos externos, vinculados à própria unidade de saúde."
      :start-open="true"
      test-id="not-our-team-accordion-toggle"
    >
      <TeamExchangeConfigBlock
        :config="stepExchangeConfig.notOurTeam"
        :errors="notOurTeamErrors"
        :on-clear-error="clearNotOurTeamError"
        testid-prefix="not-our-team"
      />
    </DropdownCard>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import DropdownCard from '@/components/designSystem/Cards/DropdownCard.vue'
import TeamExchangeConfigBlock from '@/components/designSystem/modals/EditScheduleModal/tabs/TeamExchangeConfigBlock.vue'

const props = defineProps<{
  errors: Record<string, string>
  onClearError: (field: string) => void
}>()

const store = useCreateScheduleStore()
const { stepExchangeConfig } = storeToRefs(store)

function scopeErrors(all: Record<string, string>, team: string): Record<string, string> {
  const prefix = `${team}.`
  const out: Record<string, string> = {}
  for (const [key, value] of Object.entries(all)) {
    if (key.startsWith(prefix)) out[key.slice(prefix.length)] = value
  }
  return out
}

const ourTeamErrors = computed(() => scopeErrors(props.errors, 'ourTeam'))
const notOurTeamErrors = computed(() => scopeErrors(props.errors, 'notOurTeam'))
const clearOurTeamError = (field: string) => props.onClearError(`ourTeam.${field}`)
const clearNotOurTeamError = (field: string) => props.onClearError(`notOurTeam.${field}`)
</script>
